export default __webpack_public_path__ + "static/media/indicator-icon.573ce0bb.svg";